/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {WebPage} from "../model/web-page";

@Injectable({
    providedIn: "root",
})
export class SimWebPageService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public checkPermission(url: string) {
        return super.get<boolean>(`/api/WebPage/CheckPermission`, {url: url});
    }

    public deleteAllWebPages() {
        return super.post<boolean>(`/api/WebPage/DeleteAllWebPages`, {});
    }

    public deleteWebPage(webPage: WebPage) {
        return super.post<boolean>(`/api/WebPage/DeleteWebPage`, webPage);
    }

    public exportWebPagePermissions_Url() {
        return super.getUrl(`/api/WebPage/ExportWebPagePermissions`, );
    }

    public getWebPageById(webPageId: string) {
        return super.get<WebPage>(`/api/WebPage/GetWebPageById`, {webPageId: webPageId});
    }

    public getWebPages() {
        return super.get<WebPage[]>(`/api/WebPage/GetWebPages`, );
    }

    public resetWebPagesTo(webPages: WebPage[]) {
        return super.post<boolean>(`/api/WebPage/ResetWebPagesTo`, webPages);
    }

    public updateWebPage(webPage: WebPage) {
        return super.post<boolean>(`/api/WebPage/UpdateWebPage`, webPage);
    }
}